// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 589 ? "saturday-course-finder" : chunkId) + "." + {"589":"77c0ce69","694":"663f46fb","786":"135528e0","951":"540dcb44"}[chunkId] + ".chunk.css";
};